<template>
    <admin-layout class="tenants">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1>Content Modules</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active">Teach your students how to engage important social issues and make a difference.</li>
                        </ol>
                    </nav>
                </div>
            </template>

            <hr class="my-0">

            <section class="px-4 py-3">
                <div class="module-list">
                    <div class="row">
                        <template v-for="(module, index) in modules">
                            <div class="col-4 col-xl-3" v-if="module.podcast_tags != ''">
                                <module-card :module="module"
                                              class="mb-4"/>
                            </div>
                        </template>
                    </div>
                </div>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AppContentPane from "@/Components/AppContentPane";
import AdminLayout from "@/Layouts/AdminLayout";
import ModuleCard from "@/Components/Module/ModuleCard";
import API from "@/API";
import utils from "@/mixins/utils";

export default {
    name: "Index",
    components: {
        ModuleCard,
        AdminLayout,
        AppContentPane},

    mixins: [utils],

    props: ['oauth_url'],

    data(){
        return{
            modules: [],
        }
    },

    computed: {
    },

    methods: {
        async fetchModules(){
            this.modules = await API.modules.bulk({}, this.active_tenant?.handle);
        },
    },

    beforeMount() {

    },

    created() {
        this.fetchModules();
    },

    mounted() {
        this.setTitle("Modules");
    }

}
</script>
<style lang="scss" scoped>
.embed{
    font-size: 0;
}
</style>
